import React from "react";
import { Label } from "usebeauty";
import { Logo } from "@Icons";
import "./AccessDenied.scss";

const AccessDenied = () => {
  return (
    <div className="alchera-demo-accessdenied">
      <Label text="접속 URL을 다시 확인해주세요" className="message" />
      <a
        href="https://www.alchera.ai/contact-us?utm_source=demo&utm_medium=demo&utm_campaign=web-demo"
        rel="noreferrer"
        target="_blank"
        className="logo">
        <Logo st={{ color: "#fff", fontSize: "16px" }} />
      </a>
    </div>
  );
};

export default AccessDenied;
